const FIELD_SCHEMA = {
  cat: 'category',
  opt: 'option',
  t: 'tasks',
  tu: 'tasks_in_usd',
  p: 'points',
  pu: 'points_in_usd',
  per: 'period',
  avg: 'average',
} as const;

type FlatSummary = {
  opt: string;
  type: 'total' | 'avg';
  t: number;
  tu: number;
  p: number;
  pu: number;
};

type FlatTimeSeries = {
  per: string;
  opt: string;
  t: number;
  tu: number;
  p: number;
  pu: number;
};

type FlatTeamData = {
  per: string;
  opt: string;
  team: string;
  t: number;
  tu: number;
  p: number;
  pu: number;
};

type FlattenedAllocationOfCostsData = {
  schema: typeof FIELD_SCHEMA;
  cat: string;
  summaries: FlatSummary[];
  timeSeries: FlatTimeSeries[];
  teamData: FlatTeamData[];
};

type ShowAllocationOfCostsChartLine = {
  field: string;
  show: boolean;
  color: string;
};

export { FIELD_SCHEMA };
export type {
  FlatSummary,
  FlatTeamData,
  FlattenedAllocationOfCostsData,
  FlatTimeSeries,
  ShowAllocationOfCostsChartLine,
};
